"use strict"
var KeyType={
    ctrlKey:"CtrlKey",
    shiftKey:"ShiftKey",
    None:"None"
};

module.exports=KeyType;
